var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveDocSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.245 1 1 3.245 1 6C1 8.755 3.245 11 6 11C8.755 11 11 8.755 11 6C11 3.245 8.755 1 6 1ZM7.68 7.15C7.825 7.295 7.825 7.535 7.68 7.68C7.605 7.755 7.51 7.79 7.415 7.79C7.32 7.79 7.225 7.755 7.15 7.68L6 6.53L4.85 7.68C4.775 7.755 4.68 7.79 4.585 7.79C4.49 7.79 4.395 7.755 4.32 7.68C4.175 7.535 4.175 7.295 4.32 7.15L5.47 6L4.32 4.85C4.175 4.705 4.175 4.465 4.32 4.32C4.465 4.175 4.705 4.175 4.85 4.32L6 5.47L7.15 4.32C7.295 4.175 7.535 4.175 7.68 4.32C7.825 4.465 7.825 4.705 7.68 4.85L6.53 6L7.68 7.15Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDocSvg);
export default __webpack_public_path__ + "static/media/removeDocSvg.32bf33f338347aca8e19d555c9be9539.svg";
export { ForwardRef as ReactComponent };